import { c as _c } from "react/compiler-runtime";
import type { Nexperience } from '@data-access/graphql/schema.types';
import type { NexperienceTimeslotFragment } from '@data-access/lib/gql/experience/documents';
import { formatDateWithWeekday } from '@utils/utils-format';
import type { ExperienceDayPrice } from '../_hooks/use-app-experience-day-prices';
import type { AppExperienceOffersListItemProps } from './app-experience-offers-list-item';
import { AppExperienceOffersListItem } from './app-experience-offers-list-item';
export type AppExperienceOffersDayProps = {
  day: string;
  timeslots: NexperienceTimeslotFragment[];
  experience: Pick<Nexperience, 'cancelationDeadline' | 'id' | 'currency'>;
  dayPrice?: ExperienceDayPrice;
  dayPriceFailed?: boolean;
  onExpand?: (timeslot: NexperienceTimeslotFragment) => void;
  expandedSlotId?: string | null;
} & Pick<AppExperienceOffersListItemProps, 'mode' | 'onSubmit'>;
export function AppExperienceOffersDay(t0) {
  const $ = _c(26);
  const {
    day,
    timeslots,
    experience,
    dayPrice,
    dayPriceFailed,
    mode,
    onSubmit,
    onExpand,
    expandedSlotId
  } = t0;
  let t1;
  if ($[0] !== day) {
    t1 = formatDateWithWeekday(day);
    $[0] = day;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <div className="mb-2 font-semibold sm:mb-4">{t1}</div>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== dayPrice || $[5] !== dayPriceFailed || $[6] !== expandedSlotId || $[7] !== experience || $[8] !== mode || $[9] !== onExpand || $[10] !== onSubmit || $[11] !== timeslots) {
    let t4;
    if ($[13] !== dayPrice || $[14] !== dayPriceFailed || $[15] !== expandedSlotId || $[16] !== experience || $[17] !== mode || $[18] !== onExpand || $[19] !== onSubmit) {
      t4 = timeslot => <AppExperienceOffersListItem key={timeslot.id} timeslot={timeslot} experience={experience} dayPrice={dayPrice} dayPriceFailed={dayPriceFailed} mode={mode} onSubmit={onSubmit} onExpand={onExpand} isSelected={expandedSlotId === timeslot.id} />;
      $[13] = dayPrice;
      $[14] = dayPriceFailed;
      $[15] = expandedSlotId;
      $[16] = experience;
      $[17] = mode;
      $[18] = onExpand;
      $[19] = onSubmit;
      $[20] = t4;
    } else {
      t4 = $[20];
    }
    t3 = timeslots.map(t4);
    $[4] = dayPrice;
    $[5] = dayPriceFailed;
    $[6] = expandedSlotId;
    $[7] = experience;
    $[8] = mode;
    $[9] = onExpand;
    $[10] = onSubmit;
    $[11] = timeslots;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  let t4;
  if ($[21] !== t3) {
    t4 = <ul className="flex flex-col gap-y-2 sm:gap-y-4">{t3}</ul>;
    $[21] = t3;
    $[22] = t4;
  } else {
    t4 = $[22];
  }
  let t5;
  if ($[23] !== t2 || $[24] !== t4) {
    t5 = <li>{t2}{t4}</li>;
    $[23] = t2;
    $[24] = t4;
    $[25] = t5;
  } else {
    t5 = $[25];
  }
  return t5;
}